import { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';

export interface CreditoRegularizacao { motivo: string; defesa?: string; cotacao?: string }

export function MotivoCreditoDialog({ open, onClose, onConfirm, isLoading, motivoInicial = '', defesaInicial, cotacaoInicial,
  titulo = 'Motivo do retorno da Claro' }: {
  open: boolean; onClose: () => void; onConfirm: (dados: CreditoRegularizacao) => Promise<unknown>;
  isLoading: boolean; motivoInicial?: string; defesaInicial?: string; cotacaoInicial?: string; titulo?: string;
}) {
  const [motivo, setMotivo] = useState(motivoInicial);
  const [defesa, setDefesa] = useState(defesaInicial || '');
  const [cotacao, setCotacao] = useState(cotacaoInicial || '');
  useEffect(() => {
    if (!open) return;
    setMotivo(motivoInicial); setDefesa(defesaInicial || ''); setCotacao(cotacaoInicial || '');
  }, [open, motivoInicial, defesaInicial, cotacaoInicial]);
  const pedeCotacao = cotacaoInicial !== undefined;
  const pedeDefesa = defesaInicial !== undefined;
  const faltaAlgo = !motivo.trim() || (pedeDefesa && !defesa.trim()) || (pedeCotacao && !cotacao.trim());
  const salvar = async () => {
    try {
      await onConfirm({ motivo: motivo.trim(), defesa: pedeDefesa ? defesa.trim() : undefined, cotacao: pedeCotacao ? cotacao.trim() : undefined });
      onClose();
    } catch { /* mutation exibe o erro; mantém o formulário */ }
  };
  return <Dialog open={open} onOpenChange={o => { if (!o && !isLoading) onClose(); }}>
    <DialogContent className="sm:max-w-[560px]" onClick={e => e.stopPropagation()}>
      <DialogHeader><DialogTitle>{titulo}</DialogTitle>
        <DialogDescription>Registre o retorno real da operadora. É informação interna para a BKO, o consultor e a IsabellA; não significa negativa definitiva.</DialogDescription>
      </DialogHeader>
      {pedeCotacao && <>
        <Label htmlFor="credito-cotacao">Número da cotação da operadora (obrigatório)</Label>
        <Input id="credito-cotacao" value={cotacao} onChange={e => setCotacao(e.target.value)} disabled={isLoading}
          placeholder="Como veio no retorno da Claro" />
        <p className="text-xs text-muted-foreground">A defesa é registrada por cotação. Sem este número os itens não podem ser tratados juntos.</p>
      </>}
      <Label htmlFor="credito-motivo">Motivo do retorno da Claro (obrigatório)</Label>
      <Textarea id="credito-motivo" value={motivo} onChange={e => setMotivo(e.target.value)} disabled={isLoading} rows={4} />
      {pedeDefesa && <>
        <Label htmlFor="credito-defesa">Defesa apresentada pela Prime (obrigatória)</Label>
        <Textarea id="credito-defesa" value={defesa} onChange={e => setDefesa(e.target.value)} disabled={isLoading} rows={4} />
        <p className="text-xs text-muted-foreground">Complete somente esta tentativa com o que foi efetivamente apresentado. Não cria nova tentativa nem envia documentos à Claro.</p>
      </>}
      <div className="flex justify-end gap-2">
        <Button variant="outline" onClick={onClose} disabled={isLoading}>Cancelar</Button>
        <Button onClick={() => void salvar()} disabled={isLoading || faltaAlgo}>{isLoading ? 'Salvando…' : 'Salvar'}</Button>
      </div>
    </DialogContent>
  </Dialog>;
}
